"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
/**
 * Activity Log class contant API related to System Activity Log
 * @public
 */
class ActivityLog extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Get list activity logs of user
     * @param filter - fitler to query logs
     * @param page - page index
     * @param isAdmin - is query as admin role
     * @returns
     */
    async getActivityLog(filter, page, limit) {
        try {
            const data = await this._apiV2.activityLogAPI.getListLog(filter, page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = ActivityLog;
